import { BPIAM_API } from '@/constants/API';
import { request } from '@umijs/max';

export async function getUserInfo() {
  return request(`${BPIAM_API}/userinfo/`);
}
